export default {
  title: {
    en: 'Skip to main content',
  },
}
